import { createBrowserHistory } from 'history';
import React from 'react';
import { Router } from 'react-router-dom';

export const history = createBrowserHistory();

const BrowserRouter: React.SFC = ({ children }) => <Router history={history} children={children} />;

export default BrowserRouter;
